import {Component, OnInit} from '@angular/core';
import {TransportationService} from '../../api/transportation.service';


export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}

@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.scss']
})

export class HomeContentComponent implements OnInit {

  public homeSegments = [];

  constructor(private transportationService: TransportationService) {
    this.getElements();
  }

  ngOnInit() {
  }

  getElements() {
    return this.transportationService.getAllTransportations().subscribe(
      res => this.homeSegments = res);
  }


  /*
    public getElements(): any {
      this.transportationService.getAllTransportations().forEach(elmts => elmts., console.log('vbdbdfb', this.tableaux));
      console.log('console.log    ', this.tableaux);
    }


    private showElements(): any {
      let tableau;
      tableau = this.getElements();
      console.log('tableau in showElements() AFTER!!!', this.getElements());
      for (const item of tableau) {
        console.log('foreach  ', item);
      }

      return this.elements;

    }*/


}
